import { spacings } from "@/assets/themes";
import { Block, Divider, List } from "@/components";
import polyglot from "@/utils/polyglot";
import JobsWithMonthDividers from "./JobsWithMonthDividers";

const ClosedJobs = ({ data }) => (
  <>
    {data?.length > 0 && (
      <Block marginBottom={{ xs: spacings.m, md: spacings.l }}>
        <Divider.Group />
        <List.Header>{polyglot.t("common.closed_f")}</List.Header>
        <JobsWithMonthDividers data={data} />
      </Block>
    )}
  </>
);

export default ClosedJobs;
